module.exports = __webpack_public_path__ + "img/banner-02.bbc1bcb9.jpg";